export default function Education() {
  return (
    <section id="education" className="fade-in">
      <h2>Education &amp; Certifications</h2>
      <div className="timeline">
        <div className="timeline-line"></div>
        <article className="timeline-item">
          <div className="timeline-marker"></div>
          <div className="timeline-content left">
            <h3 className="timeline-title">Bachelor of Technology(B.tech)</h3>
            <p className="timeline-institution">Srinivas Institute of Technology</p>
            <span className="timeline-date">2022 - 2026 (pursuing)</span>
            <p className="timeline-description">
              Pursuing a comprehensive B.Tech in Computer Science, focusing on software development and algorithms.
            </p>
          </div>
        </article>
        <article className="timeline-item">
          <div className="timeline-marker"></div>
          <div className="timeline-content right">
            <h3 className="timeline-title"><i className="fa-brands fa-aws"></i> AWS Certified Cloud Practitioner
              <a href="https://www.credly.com/badges/3c441770-9547-4165-8415-af0873194c2d/public_url" target="_blank" rel="noopener noreferrer"><i className="fa-solid fa-arrow-up-right-from-square"></i></a></h3>
            <p className="timeline-institution">Amazon Web Services</p>
            <span className="timeline-date">AUGUST-2025</span>
            <p className="timeline-description">
              Validated foundational, high-level understanding of AWS Cloud, services, and terminology.
            </p>
          </div>
        </article>
        <article className="timeline-item">
          <div className="timeline-marker"></div>
          <div className="timeline-content left">
            <h3 className="timeline-title"><i className="fa-brands fa-dev"></i> Devops Fundamentals
              <a href="https://courses.etrain.skillsnetwork.site/certificates/211fdab8bcea4308840268f89df3dd61" target="_blank" rel="noopener noreferrer"><i className="fa-solid fa-arrow-up-right-from-square"></i></a></h3>
            <p className="timeline-institution">IBM-Developer Skills Network.</p>
            <span className="timeline-date">SEPTEMBER-2025</span>
            <p className="timeline-description">
              Gained working knowledge of DevOps, principles, tools, workflows, lifecycle practices and process automation.
            </p>
          </div>
        </article>
        <article className="timeline-item">
          <div className="timeline-marker"></div>
          <div className="timeline-content right">
            <h3 className="timeline-title"><i className="fa-brands fa-hackerrank"></i> Java (Basics) Certificate
              <a href="https://www.hackerrank.com/certificates/8e5ce6bd6c58" target="_blank" rel="noopener noreferrer"><i className="fa-solid fa-arrow-up-right-from-square"></i></a></h3>
            <p className="timeline-institution">HackerRank</p>
            <span className="timeline-date">NOVEMBER-2025</span>
            <p className="timeline-description">
              Demonstrated proficiency in fundamental Java programming concepts and problem-solving skills.
            </p>
          </div>
        </article>
        <article className="timeline-item">
          <div className="timeline-marker"></div>
          <div className="timeline-content left">
            <h3 className="timeline-title"><i className="fa-brands fa-hackerrank"></i> Python (Basics) Certificate
              <a href="https://www.hackerrank.com/certificates/b9ee527f9404" target="_blank" rel="noopener noreferrer"><i className="fa-solid fa-arrow-up-right-from-square"></i></a></h3>
            <p className="timeline-institution">HackerRank</p>
            <span className="timeline-date">NOVEMBER-2026</span>
            <p className="timeline-description">
              Demonstrated proficiency in fundamental Python programming concepts and problem-solving skills.
            </p>
          </div>
        </article>
      </div>
    </section>
  );
}